// Kora's own brand palette: what a workspace's public helpdesk, customer portal and customer
// emails use until the workspace sets its own colours (null in storage = these values).
// Keep in sync with kora_api/src/services/brand-defaults.js.

export const KORA_BRAND = {
  accent: '#b4492a',
  accentDark: '#e27b55', // lighter Clay so it stays readable on the dark page
  light: { fg: '#1c1a15', bg: '#fbfaf6' },
  dark: { fg: '#fbfaf6', bg: '#100f0c' },
} as const;

/** Effective colours for a workspace's branding in light or dark. */
export function resolveBrandColors(
  b: { accent_color?: string | null; light_fg?: string | null; light_bg?: string | null; dark_fg?: string | null; dark_bg?: string | null } | null | undefined,
  dark: boolean,
) {
  return {
    fg: (dark ? b?.dark_fg : b?.light_fg) || (dark ? KORA_BRAND.dark.fg : KORA_BRAND.light.fg),
    bg: (dark ? b?.dark_bg : b?.light_bg) || (dark ? KORA_BRAND.dark.bg : KORA_BRAND.light.bg),
    accent: b?.accent_color || (dark ? KORA_BRAND.accentDark : KORA_BRAND.accent),
  };
}

function relLuminance(hex: string): number {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex);
  if (!m) return 0;
  const n = parseInt(m[1], 16);
  const [r, g, b] = [(n >> 16) & 255, (n >> 8) & 255, n & 255].map((c) => {
    const x = c / 255;
    return x <= 0.03928 ? x / 12.92 : ((x + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

/** Black-ish or white text, whichever reads better on the given background colour. */
export function onColor(bg: string): string {
  const l = relLuminance(bg);
  const white = 1.05 / (l + 0.05);
  const ink = (l + 0.05) / (relLuminance('#18181b') + 0.05);
  return white >= ink ? '#ffffff' : '#18181b';
}
